module.exports = __webpack_public_path__ + "static/img/step2.bd08c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step2.png
// module id = 05fU
// module chunks = 1